export default [
  { value: '.50 miles', label: '.50 miles' },
  { value: '1 miles', label: '1 miles' },
  { value: '2 miles', label: '2 miles' },
];
